import React, { useState, useEffect } from 'react';
import apiUrl from '../../Apiurl';
import ColonnaBrand from './ColonnaBrand';
import ListaProdottiBrandEditabileRiciclabile from './ListaProdottiBrandEditabileRiciclabile';
import SubHeaderTrad from './SubHeaderTrad';

function DBconTraduzioniERicicla(props) {

    const charCount = props.charCount;
    const setCharCount = props.setCharCount;
    const setProductFunction = props.setProductFunction;
    const utente = props.utente;
    const tradPermessa = props.tradPermessa;
    const setTradPermessa = props.setTradPermessa;


    const [brandSelezionato, setBrandSelezionato] = useState("TUTTI - prodotti dal più recente");
    const [listaProdottiBrand, setListaProdottiBrand] = useState([]);


    useEffect(() => {
        //copiare anche qui la stessa cosa che fa la funz da tradurre o non far visualizzare niente
        fetch(apiUrl + "/prodotti/show/all/last/100")
            .then(resp => resp.json())
            .then(data => setListaProdottiBrand(data))
    }, []);


    return (
        <div class="center sfondoBiancoTema">
            <div className='subHeader'>
                <SubHeaderTrad titolo={brandSelezionato} charCount={charCount} setCharCount={setCharCount} setTradPermessa={setTradPermessa}/>
            </div>
            <div class="cf contentSubSubHeader">
                <div class="fl w-20 w-10-ns">
                    <ColonnaBrand
                        brandSelezionato={brandSelezionato}
                        setBrandSelezionato={setBrandSelezionato}
                        setBrandFunction={setBrandSelezionato}
                        setListaProdottiBrand={setListaProdottiBrand}
                    />
                </div>
                <div class="fl w-80 w-90-ns pl2 pr2">
                    <ListaProdottiBrandEditabileRiciclabile
                        brand={brandSelezionato}
                        setProductFunction={setProductFunction}
                        listaProdottiBrand={listaProdottiBrand}
                        setListaProdottiBrand={setListaProdottiBrand}
                        /* codiceVS={product.codiceVS} */
                        tradPermessa={tradPermessa}
                        utente={utente}
                    />
                </div>
                {/* <div class="fl w-100 w-20-ns">
                    {product !== "no data" && <SchedaProdotto className="" prodotto={product} lang="it" html={false} />}
                </div> */}
            </div>
        </div>

    )
}


export default DBconTraduzioniERicicla;
